import IntegracaoErpClient from '@/api/Integracao/integracaoErp.client';

const client = new IntegracaoErpClient();

export default {
  namespaced: true,
  state: () => ({
    isLoading: false,
    isSaving: false,
    integracoes: [],
    integracaoAtual: null,
    meta: {},
    filters: {},
  }),
  actions: {
    async listar({ commit, state }) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.listar({ ...state.filters });
        commit('SET_INTEGRACOES', res.data || []);
        commit('SET_META', res.meta || {});
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async buscarPorId({ commit }, id) {
      const { data: res } = await client.buscarPorId(id);
      commit('SET_INTEGRACAO_ATUAL', res.data || null);
      return res.data;
    },
    async criar({ commit, dispatch }, payload) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.criar(payload);
        await dispatch('listar');
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async atualizar({ commit, dispatch }, { id, payload }) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.atualizar(id, payload);
        await dispatch('listar');
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async excluir({ dispatch }, id) {
      await client.excluir(id);
      await dispatch('listar');
    },
    async testar(_ctx, id) {
      const { data: res } = await client.testar(id);
      return res.data;
    },
    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters);
    },
    clearFilters({ commit }) {
      commit('CLEAR_FILTERS');
    },
  },
  mutations: {
    SET_LOADING(s, v)             { s.isLoading = v; },
    SET_SAVING(s, v)              { s.isSaving = v; },
    SET_INTEGRACOES(s, v)         { s.integracoes = v; },
    SET_INTEGRACAO_ATUAL(s, v)    { s.integracaoAtual = v; },
    SET_META(s, v)                { s.meta = v; },
    SET_FILTERS(s, filters) {
      const next = { ...s.filters };
      Object.entries(filters || {}).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') { delete next[k]; return; }
        next[k] = v;
      });
      s.filters = next;
    },
    CLEAR_FILTERS(s) { s.filters = {}; },
  },
  getters: {
    isLoading:        (s) => s.isLoading,
    isSaving:         (s) => s.isSaving,
    integracoes:      (s) => s.integracoes,
    integracaoAtual:  (s) => s.integracaoAtual,
    meta:             (s) => s.meta,
    filters:          (s) => s.filters,
  },
};
